import watchIrrf from './irrf'

export default watchIrrf
